module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "default"
    }
  }, [_vm._v("Type *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.is_person),
      expression: "entity.is_person"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "is_person", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.personTypes), function(type, idx) {
    return _c('option', {
      key: idx,
      domProps: {
        "value": type.isPerson
      }
    }, [_vm._v("\n                      " + _vm._s(type.text) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Image *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    ref: "uploader",
    attrs: {
      "uploaded-img-url": _vm.source.image ? _vm.source.image.public_url : null,
      "removable": false
    },
    on: {
      "changeFile": _vm.coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Reference Image")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('v-select', {
    staticClass: "v-select-game",
    class: _vm.vsGame,
    attrs: {
      "options": _vm.images,
      "label": "title",
      "id": "default",
      "placeholder": _vm.entity.reference.title
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_c('img', {
          attrs: {
            "src": option.thumbnail
          }
        }), _vm._v(" "), (option.title) ? _c('span', [_vm._v(_vm._s(option.title))]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.selected_ref_id),
      callback: function($$v) {
        _vm.selected_ref_id = $$v
      },
      expression: "selected_ref_id"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.entity.quotes), function(quote, key) {
    return [_c('MemoryQuote', {
      key: key,
      attrs: {
        "quote": quote,
        "number": key
      },
      on: {
        "deleteQuote": _vm.onDeleteQuote
      }
    })]
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addQuote
    }
  }, [_vm._v("\n                Add Quote\n              ")])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Memory image has added successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit memory image")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60437392","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/games/memory/Edit.vue
// module id = 922
// module chunks = 0